import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './sso.auth.scss';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import { useHistory } from 'react-router';
import { IRootState } from 'app/shared/reducers';
import { SmallTextWithIcone } from 'app/shared/components/common/text-style/small-text-with-icone';
import { getAvatarByCode } from 'app/modules/global/service/store/selectors';

const SsoAuth = props => {

  const avatar: any = useSelector<IRootState>(getAvatarByCode(5));
  const history = useHistory();
  const refHeight = useRef(null);


  const redirect = () => {
    window.location.href = `/oauth2/authorization/oidc`;
  };

  const createAccount = () => {
    window.location.href = `/auth/create-account`;
  };
  const { dataInfoCms, dataConf } = props;
  return (
    <div className="pad-msg-conn h-100">
      <div ref={refHeight}>
        <AvatarWithBadge
          hideButton
          avatar={avatar}
          title={[dataInfoCms.avatar_text]} />
      </div>
      <div className="contact-info scroll-y" style={{ height: `calc(100% - ${(refHeight.current?.clientHeight ? 50 : refHeight.current?.clientHeight) + 80}px)` }}>
        {(dataConf?.sousComponentDataList || []).find(x => x.componentDataKey === "CREATE_ACCOUNT") &&
          <div className="form-group item">
            {dataInfoCms?.components_item?.title &&
              <p className="font-weight-bold">{dataInfoCms.components_item?.title}
              </p>}

            <SmallTextWithIcone size="M" text={dataInfoCms.components_item?.text1} />
            {dataInfoCms?.components_item?.text2 &&
              <SmallTextWithIcone size="M" text={dataInfoCms.components_item?.text2} />

            }
            <ButtonLounge
              title={dataInfoCms.components_item?.btn_create_account}
              action={() => {
                createAccount();
              }}
              style={3}
            />
          </div>
        }
        {(dataConf?.sousComponentDataList || []).find(x => x.componentDataKey === "SIGIN_USER") &&
          <div className="form-group item">
            <SmallTextWithIcone size="M" text={dataInfoCms.components_item?.text3} />
            <ButtonLounge
              title={dataInfoCms.components_item?.btn_connect_label}
              action={() => {
                redirect();
              }}
              style={3}
            />
          </div>
        }
      </div>
    </div>
  );
};

export default SsoAuth;
